import querystring from 'query-string';
/**
 * 获取h5 URL参数
 * contentUrl=https://news.html5.qq.com/article?ch=003801&innerCh=&tabId=0&tagId=0&docId=8893543012891201858&showAttach=1&url=https%3A%2F%2Fpost.mp.qq.com%2Fkan%2Farticle%2F1001019041377-1820104291.html%3F_wv%3D2147483777%26sig%3D1759026c8e5f33c3eee4fb7505680d18%26article_id%3D1820104291%26time%3D1639055496%26_pflag%3D1%26x5PreFetch%3D1%26rowkey%3D98761b2007030652%26cc_media_type%3D10001&dataSrc=1&pid=1&data_type=1&ctrid=1&extenddata=%26sGrayPlatFormModelId%3D2593461%234295850%234027862%234344839%234342341%232602747%234282495%234025360%233916870%233089480%232848234%232628782%232921009%232795501%233138835%232622484%232576815%234071849%234456388%234354110%232855664%234060472%233216607%232980742%232832970%233007095%234096543%232961273%232394368%233800227%233288453%232972345%234281349%232970608%232486719%234106400%233599168%234342908%234146518%232670534%234106935%233125719%232994331%234233982%233485306%232659790%233976303%232725782%233392892%232893425%232668081%234348123%232573150%234381619%234430024%233211965%232567958%234053932%234246812%234388460%232327640%233416742%233173020%233675407%232901667%232714239%233585133%234290017%232615546%233758655%232970978%234055925%232670637%233672186%234435174%233790606%232952965%232820921%233020326%233822387%232782154%233794793%234295052%232951869%232655392%232839144%234023812%232883411%232796785%232831921%232847521%233138427%234250079%234342860%232515873%232627584%234111285%233860744%234055551%233381338%233390928%232436597%232602645%234100873%232576305%234429058%233652032%234345352%233467797%232808420%232902131%234400088%233133394%232765721%234106165%232839169%232839010%232951198%232910431%234102367%232857349%234056388%233138475%232616762%234246610%232992435%233174665%234335342%234037593%232838340%232839283%234099060%234250470%233586006%232986859%232667942%233069326%232615640%233979803%234103382%233591288%232765495%232612330%232823635%234056399%232673395%234040003%234340275%234192131%26queryId%3D1639105742110%26tabId%3D1%26pos%3D6%26sStrategyId%3D173
 */
const getUrlParam = (url) => {
  let params = querystring.parseUrl(url).query;
  let extenddata = params.extenddata || params.extInfo || params.extdata;
  extenddata = querystring.parse(extenddata);
  return {
    ...params,
    ...extenddata,
  };
};

/**
 * 前端时长上报
 */
export default class H5RecordUnitTime {
  constructor() {
    this.urlParams = getUrlParam(window?.tbird?.location?.href || location.href);
  }
  reportUnitTime() {
    const {
      pid = '-',
      ctrid = '-',
      data_type: dataType = '1',
      bizid = '1',
      docId = '-',
      sStrategyId = '-',
      subjectId = '-',
      dataSrc = '-',
      zimeitiId = '-',
      sGrayPlatFormModelId = '-',
      ch = '-',
      sModelId = '-',
      unit = 'news',
      scene = 'news',
      contenturl = location.href,
    } = this.urlParams;
    const reportObj = {
      product_id: pid,
      sence_id: ctrid,
      time_type: '1',
      grayid: sGrayPlatFormModelId || sModelId,
      data_type: dataType,
      busi_type: bizid,
      cid: docId,
      strategy: sStrategyId,
      theme: subjectId,
      data_id: dataSrc,
      media_id: zimeitiId,
    };
    if (contenturl && contenturl.indexOf('news.html5.qq.com') > -1) {
      reportObj.url_type = 'news';
    }
    const reportArr = [];
    Object.keys(reportObj).forEach((key) => {
      reportArr.push(`${key}=${reportObj[key] || '-'}`);
    });
    const reportStr = reportArr.join(';');
    console.log(reportStr);
    const args = {
      unit,
      extras: {
        kv: reportStr,
        scene,
        ch,
        request_url: contenturl,
      },
    };
    window?.browser?.app?.recordUnitTime?.(function (success) {
      console.error('recordUnitTime callback:', success);
    }, args);
  }
}

export { getUrlParam };
